import { render, staticRenderFns } from "./email.vue?vue&type=template&id=62acac66&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62acac66')) {
      api.createRecord('62acac66', component.options)
    } else {
      api.reload('62acac66', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=62acac66&", function () {
      api.rerender('62acac66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/email.vue"
export default component.exports